import React from 'react';

import { Formik } from 'formik';
import Yup from 'yup';
import {Input, SubmitButton, RGForm} from 'views/FormElements';

import UserAPI from 'service/api/UserAPI';

const Form = ({isSubmitting, values}) => {

	let submitBtn = "Create Account";
		
	if(isSubmitting === true)
			submitBtn = <span>Creating <i className="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i></span>;
	
	return <RGForm>
			<h4 style={{fontStyle: "italic", margin: "10px 0 25px 0", textAlign: "center"}}>Please fill in the form below to register.</h4>

			<Input name="username" placeholder="E.g: Ram Prasad Jhilke" type="text" label="Fullname: " style={{marginBottom: "0px", marginTop: "10px"}}/>
			<Input name="email" placeholder="E.g: somename@example.com" type="email" label="Email: " style={{marginBottom: "0px"}}/>
			<Input name="password" placeholder="E.g: 123456789 :)" type="password" label="Password: " style={{marginBottom: "0px", marginTop: "10px"}}/>

			<SubmitButton style={{marginTop: "10px"}} color="primary" disabled={isSubmitting}>
				{submitBtn}
			</SubmitButton>
	</RGForm>
};


class RegisterForm extends React.Component {

	constructor(props) {
		super(props);
		this.INIT_VALUES = {username: '', password: '', email: ''};

		if(this.props.formData)
			Object.assign(this.INIT_VALUES, this.props.formData);
			
		this.handleFormSubmission = this.handleFormSubmission.bind(this);
	}

	validationScheme() {
		return Yup.object().shape({
			email: Yup.string().email('Invalid Email address'),
			username: Yup.string().required('Enter your name'),
		    password: Yup.string().required('Enter a password').min(6, "Password cannot be less than 8 characters"),
		});
	}

	handleFormSubmission(value, {setSubmitting, resetForm}) {

		UserAPI.register(value.username, value.email, value.password, function(success) {
			setSubmitting(false);
			
			if(success === true)
				resetForm(this.INIT_VALUES);
			
		}.bind(this));
	}

	render() {
		return <Formik initialValues={this.INIT_VALUES} onSubmit={this.handleFormSubmission}
						validationSchema={this.validationScheme} component={Form} />
	}
}

export default RegisterForm;


// WEBPACK FOOTER //
// ./src/views/user/RegisterForm.js